export const styles = {
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },
  topContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: '#FFFFFF',
    padding: '0 6%',
    height: '140px',
  },
  subContainerRight: {
    display: 'flex',
  },
  subtitle1: {
    fontSize: '18px',
    fontWeight: 700,
    color: '#242528',
  },
  subtitle2: {
    fontSize: '14px',
    fontWeight: 400,
    color: '#242528',
    // lineHeight:0,
    // mt:"7px"
  },
  menuContainer: {
    height: '100%',
    background: '#FFFFFF',
    borderTop: '2px solid #dedfe1',
    borderBottom: '2px solid #dedfe1',
  },
  bottomContainer: {
    display: 'flex',
    alignItems: 'center',
    background: '#FFFFFF',
    height: '100px',
    paddingLeft: '30px',
    cursor: 'pointer',
  },
  subtitle3: {
    fontSize: '18px',
    color: '#242528',
    fontWeight: 400,
    cursor: 'pointer',
  },
  linkStyle: {
    textDecoration: 'none',
    cursor: 'pointer',
  },
};
export const navStyle = {
  listContainer: {
    padding: '0',
  },
  listButton: {
    height: '60px',
    cursor: 'pointer',
    '&.Mui-selected': {
      background: '#ececf5',
    },

    '&:hover, &.Mui-selected:hover': {
      background: '#e2e2ef',
    },
  },
  listButtonText: {
    paddingLeft: '16px',

    '& .MuiTypography-root': {
      fontSize: '18px',
      fontWeight: '400',
    },
  },
};
